import { render, staticRenderFns } from "./ShowSlideGroup.vue?vue&type=template&id=bc4d943c&scoped=true&"
import script from "./ShowSlideGroup.vue?vue&type=script&lang=js&"
export * from "./ShowSlideGroup.vue?vue&type=script&lang=js&"
import style0 from "./ShowSlideGroup.vue?vue&type=style&index=0&id=bc4d943c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4d943c",
  null
  
)

export default component.exports